import { format, parseISO } from 'date-fns';
import React from 'react';
import { Button } from '@components/ui/button';
import {
    Dialog,
    DialogContent,
    DialogFooter,
    DialogHeader,
    DialogTitle
} from '@components/ui/dialog';
import { DatePicker } from '@components/date-picker';

interface EditJoinDayDialogProps {
    open: boolean;
    joinDay?: string;
    loading?: boolean;
    onClose(): void;
    onSubmit(joinDay: string): Promise<void>;
}

export function EditJoinDayDialog({
    open,
    joinDay,
    loading,
    onClose,
    onSubmit
}: EditJoinDayDialogProps) {
    const [value, setValue] = React.useState<Date | null>(null);

    React.useEffect(() => {
        setValue(joinDay ? parseISO(joinDay) : null);
    }, [joinDay, open]);

    return (
        <Dialog open={open} onOpenChange={(next) => !next && onClose()}>
            <DialogContent className="sm:max-w-xs">
                <DialogHeader>
                    <DialogTitle>Edit Join Day</DialogTitle>
                </DialogHeader>
                <DatePicker
                    label="Join day"
                    value={value}
                    onChange={setValue}
                    maxDate={new Date()}
                />
                <DialogFooter>
                    <Button
                        variant="ghost"
                        onClick={onClose}
                        disabled={loading}
                    >
                        Cancel
                    </Button>
                    <Button
                        disabled={!value}
                        loading={loading}
                        onClick={() => {
                            if (!value) {
                                return;
                            }
                            void onSubmit(format(value, 'yyyy-MM-dd'));
                        }}
                    >
                        Save
                    </Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
}
